(function($, Drupal, once) {
  function forceDownload(blob, filename) {
    var a = document.createElement("a");

    a.download = filename;
    a.href = blob;

    document.body.appendChild(a);

    a.click();
    a.remove();
  }

  function downloadResource(url, filename) {
    if (!filename)
      filename = url
        .split("\\")
        .pop()
        .split("/")
        .pop();

    fetch(url, {
      headers: new Headers({
        Origin: location.origin
      }),
      mode: "cors"
    })
      .then(response => response.blob())
      .then(blob => {
        let blobUrl = window.URL.createObjectURL(blob);

        forceDownload(blobUrl, filename);
      })
      .catch(e => console.error(e));
  }

  Drupal.behaviors.forceDownload = {
    attach: function(context, settings) {
      once("forceDownload", "a[download]", context).forEach(function(element) {
        $(element).on("click", function(e) {
          e.preventDefault();

          downloadResource($(this).attr("href"));
        });
      });
    }
  };
})(jQuery, Drupal, once);
